export const TOKEN_ACCESS_CODE = "token_access";
export const TOKEN_REFRESH_CODE = "token_refresh";

export const STORE_REDUX = "store";
